import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  SnackBarComponent,
  SnackBarData,
} from '../../../shared/components/ui/snack-bar/snack-bar.component';
import { ApiError } from '../../../shared/interfaces';

@Injectable({ providedIn: 'root' })
export class SnackBarService {
  private readonly _snackBar = inject(MatSnackBar);

  /**
   * Abre un snackbar con contenido reutilizable.
   * @param message Texto principal
   * @param action Texto del botón de acción (opcional)
   * @param options Opciones adicionales: durationMs (milisegundos, -1 para indefinido, 5s por defecto), icon (nombre del mat-icon), type (default | success | error | info | warning)
   */
  open(
    message: string,
    options?: { durationMs?: number; icon?: string; type?: SnackBarData['type']; action?: string },
  ) {
    const data: SnackBarData = {
      message,
      action: options?.action,
      icon: options?.icon,
      type: options?.type ?? 'default',
    };
    const duration = options?.durationMs ?? 5000;

    return this._snackBar.openFromComponent(SnackBarComponent, {
      data,
      duration: duration > 0 ? duration : undefined,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: [`custom-snackbar`, `snackbar-${data.type}`],
    });
  }

  /**
   * Dispara un error en el snackbar y lanza una excepción.
   * @param error - (type: ApiError)
   */
  throwError(error: ApiError) {
    const message = error?.message || 'Ocurrió un error. Intenta nuevamente.';
    this.open(message, {
      type: 'error',
      icon: 'error',
      durationMs: 5000,
    });
    throw error;
  }
}
